import type { CSSProperties, FunctionComponent } from "react"

import styles from "./Raw.module.css"

type RawProps = {
  value: number
  name: string
  lineSize: number
}

export const Raw: FunctionComponent<RawProps> = props => {
  const { value, name, lineSize } = props

  return (
    <li className={styles.wrapper}>
      <div className={styles.name}>{name}</div>
      <div className={styles.value}> {value}</div>
      <div
        style={
          {
            "--LineWidth": `${lineSize}%`,
          } as CSSProperties
        }
        className={styles.line}
        aria-hidden="true"
      />
    </li>
  )
}
